// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3Jw9y","question":"Question_question__20-bI","description":"Question_description__3b4FC"};